// extracted by mini-css-extract-plugin
export default {"wrapper":"tabs_wrapper__v1DFT","item":"tabs_item__qIKPl","selected":"tabs_selected__U+jyY"};